module.exports = __webpack_public_path__ + "static/media/rebeccachan.c23dad9f.jpeg";